import { ReactNode } from 'react'

import styles from './CtaPill.module.scss'

export interface CtaPillProps {
  label: string
  /** Optional trailing icon (e.g. an ArrowUpRight for pills that navigate away). */
  icon?: ReactNode
  onClick?: () => void
  disabled?: boolean
}

const CtaPill = ({ label, icon, onClick, disabled = false }: CtaPillProps) => (
  <button type="button" className={styles.ctaPill} onClick={onClick} disabled={disabled}>
    {label}
    {icon}
  </button>
)

export default CtaPill
